import React from 'react';
import classnames from 'classnames';

const Table = ({ children, bordered = false }) => (
  <div className="table-responsive" style={{ position: 'relative' }}>
    <table
      className={classnames('table table-hover table-striped', {
        'table-bordered': bordered !== false,
      })}
    >
      {children}
    </table>
  </div>
);

export default Table;



// WEBPACK FOOTER //
// src/modules/common/components/Table.js